import _map from 'lodash/map';
import _cloneDeep from 'lodash/cloneDeep';
import { v4 as uuidv4 } from 'uuid';

import initialState from './initialState';
import actionType from './actionTypes';

const RefDataMatchingRuleReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_MATCHING_RULE_NAMES_SUCCESS: {
            return {
                ...state,
                matchingRuleNamesForSelectionBox: _map(action.payload, (data) => ({
                    ...data,
                    label: data.rule_name,
                    value: data.rule_name,
                })),
            };
        }
        case actionType.GET_MATCHING_MAPPING_SUCCESS: {
            return {
                ...state,
                mappingMatchings: action.payload,
            };
        }
        case actionType.GET_RULE_DATA: {
            return {
                ...state,
                ruleData: action.payload,
            };
        }
        case actionType.GET_ALL_RULE_DATA: {
            return {
                ...state,
                allRulesDetails: action.payload,
            };
        }
        case actionType.GET_PREDICTED_RULE: {
            return {
                ...state,
                predictedRule: action.payload,
            };
        }
        case actionType.GET_EXTRACTED_DATA: {
            return {
                ...state,
                extractedData: action.payload,
            };
        }
        case actionType.CLEAN_RULE_DATA: {
            return {
                ...state,
                ruleData: null,
            };
        }
        default:
            return state;
    }
};

export default RefDataMatchingRuleReducer;
